import script from "./HistoryTask.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryTask.vue?vue&type=script&setup=true&lang=js"

import "./HistoryTask.vue?vue&type=style&index=0&id=18653ea2&lang=scss&scoped=true"
import "./HistoryTask.vue?vue&type=style&index=1&id=18653ea2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18653ea2"]])

export default __exports__